'use strict';

angular.module('mean.projects').factory('taskRescheduleService', ['$filter', '$rootScope', 'daysDifferenceService', 'GeneralTasks', 'tradeCodeService', 'ProjectTasks', '$q', 'toaster',
    function($filter, $rootScope, daysDifferenceService, GeneralTasks, tradeCodeService, ProjectTasks, $q, toaster) {
        //get the general tasks
        GeneralTasks.query({'get_locations': true }, 
                function(global_tasks) {
            gtasks = global_tasks;
        });

        var gtasks = [];

        var scheduleOne = function(user, task, start_date, end_date, reason) {
            //have to round up the returned numbers since start/end 
            //can be on same day now.
            var new_duration_days = Math.ceil(daysDifferenceService.getDiffTwoDays(
                        start_date, end_date));

            var new_days_to_start = Math.ceil(daysDifferenceService.getDiffTwoDays(
                        task.start_date, start_date));

            var change_info = { 
                from: new Date(task.start_date),
                to: new Date(start_date),
                date_changed: new Date(),
                duration_changed: (new_duration_days === task.days)?false:true,
                original_duration: task.days,
                original_offset: task.days_offset,
                reason: reason
            }

            var note = {
                date: new Date(),
                comment: 'Changed the start date to ' + start_date + ' due to reason ' + reason,
                username: user.username
            }

            if(reason === 'Site Not Ready' || reason === 'Weather') {
                task.status = 'delayed_start';
            } else {
                task.status = 'work_stoppage';
            }

            task.days = new_duration_days;
            task.days_offset = task.days_offset + new_days_to_start;
            task.start_date = new Date(start_date);
            task.end_date = new Date(end_date);
            task.prior_start_dates.push(change_info);
            task.notes.push(note);

            return task;
        };

        var scheduleByDays = function(user, task, start_date, days_offset, reason) {
            start_date = daysDifferenceService.getValidDate(start_date);
            var end_date = moment(moment(start_date).add(days_offset-1, 'days'));
            end_date.add(8, 'hours');
            end_date.add(30, 'minutes');
            end_date = new Date(daysDifferenceService.getValidDate(end_date));

            var new_duration_days = task.days; //duration of the task in days

            var new_days_to_start = days_offset; //number of days from start of project

            var change_info = { 
                from: new Date(task.start_date),
                to: new Date(start_date),
                date_changed: new Date(),
                duration_changed: (new_duration_days === task.days)?false:true,
                original_duration: task.days,
                original_offset: task.days_offset,
                reason: reason
            }

            var note = {
                date: new Date(),
                comment: 'Changed the start date to ' + start_date + ' due to reason ' + reason,
                username: user.username
            }

            if(reason === 'Site Not Ready' || reason === 'Weather') {
                task.status = 'delayed_start';
            } else {
                task.status = 'work_stoppage';
            }

            task.days = new_duration_days;
            task.days_offset = task.days_offset + new_days_to_start;
            task.start_date = new Date(start_date);
            task.end_date = new Date(end_date);
            task.prior_start_dates.push(change_info);
            task.notes.push(note);

            return task;
        };

        /* this will reschedule each task within the tasks list
         * and will not affect the follow on tasks.
         */
        var scheduleNoPush = function(user, tasks, start_date, end_date, reason) {
            tasks.forEach(function(task) {
                scheduleOne(user, task, start_date, end_date, reason);
                task.$update();
            });

            return tasks;
        };

        var subtractToValidDate = function(date, days) {
            //i need to subtract (days) working and skip
            //any invalid dates
            var to_days = 0;
            var starting = moment(date);
            while(to_days < days) {
                starting.subtract(1, 'days');
                if(!daysDifferenceService.disabled(new Date(starting), 'day')) {
                    to_days++;
                }
            }
            return starting;
        }

        var addToValidDate = function(date, days) {
            //i need to subtract (days) working and skip
            //any invalid dates
            var to_days = 0;
            var starting = moment(date);
            while(to_days < days) {
                starting.add(1, 'days');
                if(!daysDifferenceService.disabled(new Date(starting), 'day')) {
                    to_days++;
                }
            }
            return moment(starting);
        }

        /* this will reschedule each task within the task list
         * and all follow-on tasks.  We will need to grab the Main
         * task to determine the location of task to be moved.
         *
         * the move algorithm will be based on location (inside,
         * outside, or both).  If the location is inside, it will
         * push back all inside tasks and leave the outside tasks
         * alone.
         *
         * once a both task has been reached, then it will push
         * back all follow-on tasks.  The same will be done for 
         * if the task is outside.
         *
         * if the initial task to push back is both, then all will
         * be pushed back.
         */
        var task_location = {};
        var bothString = {};
        bothString = 'Both';
        var schedulePush = function(user, tasks, start_date, end_date, reason) {
            /* Ok...so...The tasks passed in to this function are the
             * tasks the operator selected to adjust as per the
             * algorithm denfined above.  This works nicely if only
             * one task is actually selected but we can not depend on
             * that.  We must 
             * 1. grab the lists of all tasks the current task is associated with
             * 2. order the list of tasks and jump forward to days_offset
             * 3. reschedule the current task and adjust duration
             * 4. reschedule all follow-on tasks without adjusting duration
             * 5. if a subsequent task from the same phase/lot is found,
             *    then we need to adjust just that task based on the input
             * 6. repeat on to the next task.
             */
            var updated_tasks = $q.defer();
            var update_list = [];
            start_date = moment(start_date);
            tasks.forEach(function(task) {
                var deferred = $q.defer();
                var project_start_date = subtractToValidDate(task.start_date, task.days_offset);
                var diff_days = 0;

                if(start_date.isBefore(moment(task.start_date))) {
                    //this section is going back in time.
                    //we are going to get the old days_offset of the original task
                    //and then we're going to update the task with the new dates
                    //and then get the new days_offset.  For all the tasks that
                    //fall within that days_offset old/new range, they will be
                    //resheduled to the prior work day.  Then all tasks that 
                    //fall after new days_offset will be scheduled accordingly.
                    diff_days = Math.ceil(daysDifferenceService.getDiffTwoDays(
                                            start_date, task.start_date));
                    console.log('The number of diff_days computed ' + diff_days);
                    var early_days_offset = task.days_offset - diff_days;

                    var q_call = ProjectTasks.query({
                        'phase': task.phase, 'lot': task.lot, 'project_id': task.project_id},
                            function(current_task_list) {                        
                        var not_worried_about = _.remove(current_task_list, function(dbtask) {
                            return dbtask.days_offset < early_days_offset;
                        });
                        var in_the_middle = _.remove(current_task_list, function(dbtask) {
                            return dbtask.days_offset < task.days_offset;
                        });

                        var same_day = _.remove(current_task_list, function(dbtask) {
                            return dbtask.days_offset == task.days_offset;
                        });

                        //get the business day prior to start date so we
                        //can adjust all the middle tasks to the day prior
                        var current_day = moment(start_date).subtract(1, 'day');
                        while(daysDifferenceService.disabled(new Date(current_day), 'day')) {
                            current_day.subtract(1, 'day');
                        }

                        _.each(in_the_middle, function(item) {
                            item = scheduleByDays(user, 
                                item, 
                                current_day,
                                item.days,
                                reason);
                            item.days_offset = 
                                daysDifferenceService.getDaysFromStart(
                                    project_start_date, item.start_date) + 1;
                            item.$update(function(success) {

                            }, function(error) {
                                toaster.pop('error', 'Task Save Error', error)
                            });
                        });

                        _.each(same_day, function(item) {
                            item = scheduleOne(user, 
                                item, 
                                start_date, 
                                end_date, 
                                reason);
                            item.days_offset = 
                                daysDifferenceService.getDaysFromStart(
                                    project_start_date, item.start_date) + 1;
                            item.$update(function(success) {

                            }, function(error) {
                                toaster.pop('error', 'Task Save Error', error)
                            });
                        });

                        _.each(current_task_list, function(item) {
                            item = scheduleByDays(user, 
                                item, 
                                subtractToValidDate(item.start_date, diff_days),
                                item.days,
                                reason);
                            item.days_offset = 
                                daysDifferenceService.getDaysFromStart(
                                    project_start_date, item.start_date) + 1;
                            item.$update(function(success) {

                            }, function(error) {
                                toaster.pop('error', 'Task Save Error', error)
                            });
                        });

                        //add back to list so the view can update properly
                        _.each(in_the_middle, function(item) {
                            current_task_list.push(item);
                        });

                        _.each(same_day, function(item) {
                            current_task_list.push(item);
                        });

                        current_task_list = $filter('orderBy')(current_task_list, 'days_offset', false);
                    });
                } else {
                    //this section is moving tasks forward in time.
                    diff_days = Math.ceil(daysDifferenceService.getDiffTwoDays(
                                            task.start_date, start_date));

                    console.log('The number of diff_days computed ' + diff_days);
                    var duration_increase = 0;

                    var q_call = ProjectTasks.query({
                        'phase': task.phase, 'lot': task.lot, 'project_id': task.project_id},
                            function(current_task_list) {
                        var not_worried_about = _.remove(current_task_list, function(dbtask) {
                            return dbtask.days_offset < task.days_offset;
                        });

                        var ordered_list = $filter('orderBy')(current_task_list, 'days_offset', false);
                        
                        _.each(ordered_list, function(item) {
                            if(item._id === task._id) {
                                //item.start_date = moment(start_date);
                                // item.end_date = moment(end_date);
                                item.days = Math.ceil(daysDifferenceService.getDiffTwoDays(
                                    start_date, end_date));

                                duration_increase = parseInt(item.days-1);
                                item = scheduleOne(user, 
                                    item, 
                                    start_date, 
                                    end_date, 
                                    reason);
                                item.days_offset = 
                                    daysDifferenceService.getDaysFromStart(
                                        project_start_date, item.start_date) + 1;
                                item.$update(function(success) {

                                }, function(error) {
                                    toaster.pop('error', 'Task Save Error', error)
                                });
                            } else {
                                console.log(duration_increase);
                                item = scheduleByDays(user, 
                                    item, 
                                    addToValidDate(item.start_date, diff_days + duration_increase),
                                    item.days,
                                    reason);
                                item.days_offset = 
                                    daysDifferenceService.getDaysFromStart(
                                        project_start_date, item.start_date) + 1;
                                item.$update(function(success) {

                                }, function(error) {
                                    toaster.pop('error', 'Task Save Error', error)
                                });
                            }
                        });
                    });
                }

                q_call.$promise.then(function(result) {
                    $rootScope.$emit('RescheduleEventComplete', result);
                });
            });
            
            return updated_tasks.promise;
        };

        return {
            scheduleOne: scheduleOne,
            scheduleNoPush: scheduleNoPush,
            schedulePush: schedulePush
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/task-reschedule-service.js